<template>
  <span>
    <transition name="yxy-fade">
      <div class="modal-mask" v-show="visible" @click="mask"></div>
    </transition>
    <div class="modal-wrap" :class="{'wrap-hide': !visible}">
      <transition name="yxy-ease">
        <div class="modal" :style="modalStyle" v-show="visible">
          <div class="modal-content" :style="contentStyle">
            <a class="modal-close" v-if="closable" @click="close">
              <slot name="close"><Icon type="ios-close-empty"></Icon></slot>
            </a>
            <div class="modal-header" v-if="$slots.header || title">
              <slot name="header"><div class="modal-header-inner">{{ title }}</div></slot>
            </div>
            <div class="modal-body" :style="bodyStyle" v-html="content">
              <slot></slot>
            </div>
            <div class="modal-footer" v-if="!footerHide">
              <div class="wraper">
                <slot name="footer">
                  <y-button type="default" mini @click.native="cancel">{{ cancelText }}</y-button>
                  <y-button type="primary" mini @click.native="ok">{{ okText }}</y-button>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </span>
</template>

<script>
import Icon from './common/icon'
import YButton from './common/y-button'
export default {
  components: {Icon, YButton},
  props: {
    value: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: false
    },
    maskClosable: {
      type: Boolean,
      default: true
    },
    title: String,
    content: String,
    width: {
      type: [Number, String],
      default: 520
    },
    okText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    loading: {
      type: Boolean,
      default: false
    },
    footerHide: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      visible: this.value,
      modalStyle: {},
      contentStyle: {},
      bodyStyle: {}
    }
  },
  computed: {
    pageHeight () {
      return this.$store.getters.getWinHeight
    }
  },
  watch: {
    value (val) {
      this.visible = val
      if (val) {
        this.fixSafariOverflowScrolling('auto')
      }
    }
  },
  mounted () {
    this.$overflowScrollingList = document.querySelectorAll('.yxy-fix-safari-overflow-scrolling')
    this.modalStyle = {
      width: 'auto',
      height: (this.pageHeight - 40) + 'px',
      margin: '20px 15px'
    }
    this.contentStyle = {
      height: (this.pageHeight - 40) + 'px'
    }
    this.bodyStyle = {
      height: (this.pageHeight - 40 - 100) + 'px'
    }
  },
  methods: {
    close () {
      this.visible = false
      this.fixSafariOverflowScrolling('touch')
      this.$emit('input', false)
      this.$emit('on-cancel')
    },
    mask () {
      if (this.maskClosable) {
        this.close()
      }
    },
    cancel () {
      this.close()
    },
    ok () {
      this.visible = false
      this.fixSafariOverflowScrolling('touch')
      this.$emit('input', false)
      this.$emit('on-ok')
    },
    fixSafariOverflowScrolling (type) {
      if (!this.$overflowScrollingList.length) return
      if (!/iphone/i.test(navigator.userAgent)) return
      for (let i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type
      }
    }
  }
}
</script>

<style lang="less">

</style>
